import { MarkNode } from '@lexical/mark';
import { $create, LexicalNode, RangeSelection } from 'lexical';

export class RightAlignedMarkNode extends MarkNode {
  $config() {
    return this.config('right-aligned-mark', { extends: MarkNode });
  }

  static importDOM(): null {
    return null;
  }

  createDOM(): HTMLElement {
    const element = document.createElement('span');
    element.dataset['rightAligned'] = 'true';
    return element;
  }

  updateDOM(): boolean {
    return false;
  }

  insertNewAfter(_selection: RangeSelection, restoreSelection = true): RightAlignedMarkNode {
    const newMark = $createRightAlignedMarkNode();
    for (const id of this.getIDs()) {
      newMark.addID(id);
    }
    this.insertAfter(newMark, restoreSelection);
    return newMark;
  }
}

export function $createRightAlignedMarkNode(): RightAlignedMarkNode {
  return $create(RightAlignedMarkNode);
}

export function $isRightAlignedMarkNode(
  node: LexicalNode | null | undefined,
): node is RightAlignedMarkNode {
  return node instanceof RightAlignedMarkNode;
}
